import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SUBMODULE_LIST } from "../apiRoutes";

// Define the expected response type
interface Submodule {
  subModuleId: string;
  subModuleName: string;
  moduleId: string;
  moduleName: string;
  description?: string;
  isActive: boolean;
}

interface SubmodulesResponse {
  data: {
    records: Submodule[];
    pagination: { totalRecords: number }[];
  }[];
}

const fetchSubmodules = async (moduleId: string, curriculum_id?: string) => {
  const response = await axiosAuth.get<SubmodulesResponse>(SUBMODULE_LIST, {
    params: { module_id:moduleId, ...curriculum_id ? {curriculum_id} : {}},
  });
  return response.data;
};

export const useGetSubmodulesQuery = (
  moduleId: string,
  curriculum_id?: string,
  queryParams?: UseQueryOptions<SubmodulesResponse, Error, SubmodulesResponse, ["submodules", string]>
) =>
  useQuery<SubmodulesResponse, Error, SubmodulesResponse, ["submodules", string]>({
    queryKey: ["submodules", moduleId, curriculum_id],
    queryFn: () => fetchSubmodules(moduleId, curriculum_id),
    enabled: !!moduleId, // Only run query if moduleId is provided
    ...(queryParams as any),
  });
